import { IS_PROD } from 'settings';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    gtag: any;
  }
}

type EventProps = {
  category: string;
  action: string;
  label?: string;
};

export const sendEventToGA = ({ category, action, label }: EventProps) => {
  if (IS_PROD) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label
    });
  }
};
